import { faExternalLink } from '@fortawesome/pro-thin-svg-icons';

import { as, removeEmptyProperties } from '@utils';

import { Icon, Link } from '@components';

type Props = {
  title: string;
  source: string;
  metricsUrl: string;
  resource?: string;
  params?: Partial<Record<string, string>>;
};

export const DashboardReportLink = ({
  title,
  source,
  params,
  resource = source,
  metricsUrl,
}: Props) => {
  const makeUrl = (): string => {
    const url = new URL(`${metricsUrl}/d/${resource}/${source}`);

    if (params) {
      const search = new URLSearchParams(
        removeEmptyProperties<string>(as.o(params)),
      );

      url.search = search.toString();
    }

    return url.toString();
  };

  const url = makeUrl();

  return (
    <Link
      theme
      external
      blank
      className="flex h-56 w-56 flex-col items-center justify-center gap-4 rounded-xl border border-neural-02 bg-white p-4 transition-colors hover:border-rebecca"
      to={url}
    >
      <Icon
        icon={faExternalLink}
        className="h-14 w-14 text-[48px] text-primary"
      />
      <p className="text-center text-h6 font-400 capitalize">{title}</p>
    </Link>
  );
};
